// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"a61044ce","216":"c8be4e55","221":"9ecad714","268":"b008101b","297":"e03881cb","757":"19735543","864":"1b5bbe0f"}[chunkId] + ".chunk.js";
};